import React from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';

import {labels} from '../../../../util/utils';
import {getEntityAdmins, getProjectOwners} from '../../../../util/contactsDB';

import Accordion from '../../../CoreWrappers/Accordion';
import StyledContent from './StyledContent';
import CountDisplayV2 from '../../CountDisplayV2';

const Members = () => {
	const {projectOwnerCount, projectAdminCount, keyContactsCount} = useSelector(({project}) => ({
		projectOwnerCount: getProjectOwners(project?.users ?? []).length,
		projectAdminCount: getEntityAdmins(project?.orgStructure ?? []).length,
		keyContactsCount: project.keyContactsCount ?? 0
	}));

	const list = [
		{
			key: 1,
			count: projectOwnerCount,
			label: labels.projectOwnersLabel,
			singleLabel: labels.projectOwnerLabel
		},
		{
			key: 2,
			count: projectAdminCount,
			label: labels.entityAdmins,
			singleLabel: labels.entityAdmin
		},
		{
			key: 3,
			count: keyContactsCount,
			label: labels.keyContacts,
			singleLabel: labels.keyContact
		}
	];

	return (
		<Accordion trigger={() => labels.membersTitle}>
			<StyledContent>
				{list.map(({key, count, label, singleLabel}) => {
					const props = {
						key,
						label,
						singleLabel,
						count
					};

					return <CountDisplayV2 {...props} />;
				})}
			</StyledContent>
		</Accordion>
	);
};

Members.propTypes = {};

Members.defaultProps = {};

export default Members;
